var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page container", attrs: { id: "course-chooser" } },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-10 col-md-offset-1" },
          [
            _c("back-button", { attrs: { backRoute: { name: "areas" } } }),
            _vm._v(" "),
            _c("div", { staticClass: "row area-details" }, [
              _c("div", { staticClass: "col-xs-8" }, [
                _c("h4", [_vm._v(_vm._s(_vm.$t("AREA")))]),
                _vm._v(" "),
                _c("h1", [_vm._v(_vm._s(_vm.currentArea.name))]),
                _vm._v(" "),
                _c("p", { staticClass: "area-description" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.currentArea.description) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "area-progress-container" }, [
                  _c(
                    "span",
                    { staticClass: "area-progress-item svg-line" },
                    [
                      _c("check-badge-grey", { staticClass: "svg-icon" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.completeCategoriesCount)
                          ),
                          _c("slash", {
                            staticStyle: {
                              width: "6px",
                              height: "10px",
                              margin: "0 2px",
                            },
                          }),
                          _c("span", { staticClass: "all-count" }, [
                            _vm._v(_vm._s(this.currentCategories.length)),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "vertical-divider",
                    staticStyle: { height: "14px" },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "area-progress-item svg-line" },
                    [
                      _c("level", { staticClass: "svg-icon" }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                " +
                            _vm._s(this.currentProgress.level.name) +
                            "\n              "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-4" }, [
                _c("img", {
                  staticClass: "img img-responsive",
                  attrs: { src: _vm.currentArea.image },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-7" },
                [
                  _vm.showAssignedTests ? _c("assigned-tests") : _vm._e(),
                  _vm._v(" "),
                  _c("h3", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.$t("CATEGORY_CHOOSER_COURSES"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.currentCategories, function (category) {
                    return _c(
                      "div",
                      {
                        key: category.id,
                        staticClass: "card",
                        staticStyle: { "margin-bottom": "20px" },
                      },
                      [
                        _c("div", { staticClass: "row specific-course" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-7 specific-course-description",
                            },
                            [
                              _c("div", { staticClass: "course-heading" }, [
                                _c("div", { staticClass: "course-tags" }),
                                _vm._v(" "),
                                _c("h1", [_vm._v(_vm._s(category.name))]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "progress-and-button" },
                                [
                                  _c("progress-bar", {
                                    attrs: {
                                      percent: _vm.categoryProgressPercent(
                                        category.id
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn primary-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.goToCategory(category.id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.categoryProgressPercent(
                                              category.id
                                            ) === 0
                                              ? _vm.$t("BEGIN")
                                              : _vm.categoryProgressPercent(
                                                  category.id
                                                ) === 100
                                              ? _vm.$t("VIEW_AGAIN")
                                              : _vm.$t("CONTINUE")
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-5" }, [
                            _c(
                              "div",
                              { staticClass: "specific-course-image" },
                              [
                                _c("img", {
                                  staticClass: "img img-responsive",
                                  attrs: { src: category.image_path },
                                }),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-5" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12" }, [
                    _c("h3", { staticClass: "section-title" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("CATEGORY_CHOOSER_ACHIEVEMENTS")) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "category-achievements" },
                      [
                        _vm._l(
                          _vm.currentUnlockedAchievements,
                          function (achievement) {
                            return _c(
                              "div",
                              {
                                key: achievement.id,
                                staticClass: "category-achievement unlocked",
                                attrs: { title: achievement.name },
                              },
                              [
                                _c("img", {
                                  attrs: { src: achievement.image_path },
                                }),
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm._l(
                          _vm.currentLockedAchievements,
                          function (achievement) {
                            return _c("div", {
                              key: achievement.id,
                              staticClass: "category-achievement locked",
                            })
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }